(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-cart"]) return;
  try {
    
$( document ).ready(function() {
 
$('.stockValue').each(function(){
 
   $(this).parent().find('.js-qty__num').attr({
           "max" : $(this).text()
        }); 

 

 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
 // Look for an element with class 'product-recommendations'
 var productRecommendationsSection = document.querySelector(".product-recommendations");
 if (productRecommendationsSection === null) { return; }
 // Read product id from data attribute
 var productId = productRecommendationsSection.dataset.productId;
 // Read base URL from data attribute
 var baseUrl = productRecommendationsSection.dataset.baseUrl;
 // Read limit from data attribute
 var limit = productRecommendationsSection.dataset.limit;
 // Build request URL
 var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
 // Create request and submit it using Ajax
 var request = new XMLHttpRequest();
 request.open("GET", requestUrl);
 console.log('REQUEST URL ' + requestUrl);
 request.onload = function() {
   if (request.status >= 200 && request.status < 300) {
     var container = document.createElement("div");
     container.innerHTML = request.response;
     productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
   }
 };
 request.send();
};

// Listen for changes done in the Theme Editor
document.addEventListener("shopify:section:load", function(event) {
 if (event.detail.sectionId === "product-recommendations") {
   loadProductRecommendationsIntoSection();
 }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-banner-v1"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
     var swslider = $("#lightSlider-banner").lightSlider({
        item: 2, 
        autoWidth: false,
        slideMove: 1, // slidemove will be 1 if loop is true
        slideMargin: 65,
        speed: 600, //ms'
        auto: true,
        loop: true,
        slideEndAnimation: true,
        pause: 4000,
 
        keyPress: false,
        controls: false,
        prevHtml: '',
        nextHtml: '',
 
        rtl:false,
        adaptiveHeight:false,

 
        enableTouch:true,
        enableDrag:true,
        freeMove:true,
        swipeThreshold: 40,
 
        responsive : [
			{
                breakpoint:1199,
                settings: {
                    slideMargin: 40
                }
            },
			{
                breakpoint:768,
                settings: {
                    slideMargin: 30 
                }
            },
            {
                breakpoint:576,
                settings: {
                    item:4,
                    slideMove:1,
			        adaptiveHeight:true,
					auto: false,
					pager: false,
					enableTouch:false,
					loop: false

                }
            } 
        ],
		onSliderLoad: function() {
            $('#lightSlider-banner').removeClass('cS-hidden');
		}
    });
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video-box-v2"] && !Shopify.designMode) return;
  try {
    
  $('.video-play-button').fancybox({
    toolbar: false,
    smallBtn: false,
    width: 400,
    height: 300,
    autoSize: false
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video-box"] && !Shopify.designMode) return;
  try {
    
$('.video-play-button').fancybox({
	toolbar  : false,
	smallBtn : false,
	width  : 400,
    height : 300,
    autoSize : false
})

  } catch(e) { console.error(e); }
})();
})();
